import { MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

const MARKETPLACE_LEFT_AND_RIGHT_MARGIN_TABLET = 48;

export const OuterResultsContentWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: nowrap;
  padding: 0 ${MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE}px 16px;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 10px ${MARKETPLACE_LEFT_AND_RIGHT_MARGIN_TABLET}px 0;
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    padding-left: 0;
  }
`;
